import React from 'react'
import PropTypes from 'prop-types'
import { useSpring, animated } from 'react-spring'

import ExtendedInput from 'components/Forms/FormElements/ExtendedInput/ExtendedInput'

const BosShareUrlInput = ({ bosShareUrl, animateIn = false }) => {
    const enterSpring = useSpring({
        config: {
            duration: 2000
        },
        from: {
            backgroundColor: '#daffa3',
        },
        to: {
            backgroundColor: 'white',
        }
    })

    return (
        <ExtendedInput>
            <animated.input
                style={animateIn ? enterSpring : null}
                type="text"
                name="bos-share-link"
                readOnly
                value={bosShareUrl}
                onClick={(e) => {
                    e.target.select()
                }}
            />
        </ExtendedInput>
    )
}

BosShareUrlInput.propTypes = {
    bosShareUrl: PropTypes.string.isRequired,
    animateIn: PropTypes.bool,
}

export default BosShareUrlInput
